export const notificationsApiEndpoints = {
  getNotifications: (page: number, limit: number) =>
    `/notifications?page=${page}&limit=${limit}`,
  sendNotification: `/notifications`,
  deleteNotification: (id: number) => `/notifications/${id}`,
};
